var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconPayments(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 16,
    viewBox: "0 0 16 16",
    width: 16,
    xmlns: "http://www.w3.org/2000/svg",
    fill: "rgb(88, 106, 218)",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m1 4h14c.5522847 0 1 .40701386 1 .90909091v8.18181819c0 .502077-.4477153.9090909-1 .9090909h-14c-.55228475 0-1-.4070139-1-.9090909v-8.18181819c0-.50207705.44771525-.90909091 1-.90909091zm1-3h12c.5522847 0 1 .44771525 1 1v1h-14v-1c0-.55228475.44771525-1 1-1zm6 10.5c1.38071187 0 2.5-1.1192881 2.5-2.5 0-1.38071187-1.11928813-2.5-2.5-2.5s-2.5 1.11928813-2.5 2.5c0 1.3807119 1.11928813 2.5 2.5 2.5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPayments);
export default __webpack_public_path__ + "static/media/icon-payments.4ddc14f37483b4874b0c646aff58685f.svg";
export { ForwardRef as ReactComponent };